<template>
  <div class="line" v-show="show">
    --- 到底了 ---
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false
    }
  },
  created () {
    setTimeout(() => {
      this.show = true
    }, 500);
  }
}
</script>

<style lang="scss" scoped>
.line {
  margin: rem(20) 0;
  font-size: rem(12);
  color: #ccc;
  text-align: center;
}
</style>